import api from './api';

/**
 * RMIS Expanded Carrier API lookup (DOT / MC_MX). The backend queries RMIS,
 * parses the XML, and returns the full section/field listing for display plus a
 * `carrier` subset the Carrier Profiles drawer copies into the record on
 * "Update Carrier".
 */
export interface RmisField {
  label: string;
  value: string;
}

export interface RmisSection {
  name: string;
  fields: RmisField[];
}

/** Carrier fields mapped from RMIS into carrierprofile columns. */
export interface RmisCarrier {
  truckername?: string;
  truckerscac?: string;
  mcnum?: string;
  dotnum?: string;
  truckeraddress?: string;
  truckercity?: string;
  truckerstate?: string;
  truckerzip?: string;
  lastconfirmdatetime?: string;
  confirmed?: string; // 'Y' | 'N'
}

export interface RmisLookupResult {
  query_type: string;
  query_id: string;
  result: string;
  sections: RmisSection[];
  carrier: RmisCarrier;
  errors: string[];
}

export async function rmisLookup(
  queryType: 'DOT' | 'MC_MX',
  queryId: string,
): Promise<RmisLookupResult> {
  const res = await api.get('/rmis/lookup', {
    params: { query_type: queryType, query_id: queryId },
  });
  return res.data as RmisLookupResult;
}
